export const membershipRoles = {
  OWNER: 'consumer_org_owner',
  MEMBER: 'consumer_org_member'
}

export const membershipRoles_options = {
  [membershipRoles.OWNER]:"enums:membershipRole_option_owner",
  [membershipRoles.MEMBER]:"enums:membershipRole_option_member"
}